import React, { Component } from 'react';

import { Switch, Route } from "react-router-dom";
import HomeScreen from '../../Screens/HomeScreen/HomeScreen.js';
import Service from '../../Screens/ServiceScreen/ServiceScreen.js';

export default class Container extends Component {

  static defaultProps = {
    datas: {},
  };

  render() {
    const renderMergedProps = (component, ...rest) => {
      const finalProps = Object.assign({}, ...rest);
      return (
        React.createElement(component, finalProps)
      );
    }

    const PropsRoute = ({ component, ...rest }) => {
      return (
        <Route {...rest} render={routeProps => {
          return renderMergedProps(component, routeProps, rest);
        }}/>
      );
    }

    return (
      <Switch>
        <PropsRoute exact path="/annuaire/" component={HomeScreen} datas={this.props.datas} />
        <Route path="/annuaire/service:datas" component={Service} />
      </Switch>
    );
  }
}

// <Route path='/service:datas' render={(props) => (
//   <Service {...props} data={extraProps}/>
// )}/>